export default "__VITE_ASSET__CfllgoNO__"